import React from 'react';

import HintIcon from '@lt/components/icons-react/rebrand/QuestionFill';
import styled from 'styled-components';
import { TITLE } from './constants';

interface IWhatIncludedInPrice {
  className?: string;
}

const WhatIncludedInPrice: React.FC<IWhatIncludedInPrice> = ({ className }) => (
  <Container className={className}>
    <StyledHintIcon />
    {TITLE}
  </Container>
);

const Container = styled.div`
  display: flex;
  align-items: center;

  color: var(--grey1);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

const StyledHintIcon = styled(HintIcon)`
  height: 16px;
  margin-right: 2px;
  path {
    fill: var(--grey1);
  }
`;

export default WhatIncludedInPrice;
